import { render, staticRenderFns } from "./organizationTab.vue?vue&type=template&id=14cafdab&scoped=true&"
import script from "./organizationTab.vue?vue&type=script&lang=ts&"
export * from "./organizationTab.vue?vue&type=script&lang=ts&"
import style0 from "./organizationTab.vue?vue&type=style&index=0&id=14cafdab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cafdab",
  null
  
)

export default component.exports